'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';

const BASE =
  'w-full bg-surface-3 border border-border-subtle rounded-sm px-3 py-2 text-text-primary text-sm placeholder:text-text-tertiary focus:border-accent focus:outline-none transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed resize-y min-h-[80px]';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...rest }, ref) => {
    return <textarea ref={ref} className={cn(BASE, className)} {...rest} />;
  }
);
Textarea.displayName = 'DsTextarea';
